<button mat-raised-button *appRole="['Documentos.Crear']" color="primary" [routerLink]="['/documento/nuevo']">
    <mat-icon>add</mat-icon>
    Nuevo documento
</button>
